import React from 'react';
const DownloadIcon = () => {
    return (React.createElement("svg", { width: "19", height: "18", viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M14.75 7.125H11.75V2.625H7.25V7.125H4.25L9.5 12.375L14.75 7.125ZM8.75 8.625V4.125H10.25V8.625H11.1275L9.5 10.2525L7.8725 8.625H8.75ZM4.25 13.875H14.75V15.375H4.25V13.875Z", fill: "#363948" })));
};
export default DownloadIcon;
